export enum EditableSection {
	NONE,
	PROFILE,
	SUMMARY_ALL,
	SUMMARY_CONTACTS,
	CURRENT_OCCUPATION,
	ORGANIZATION,
	PERSONAL_INFORMATION,
	MY_LOCATION_WITH,
	PROFESSIONAL_EXPERIENCE,
	ROLES,
	SPECIALTIES,
	INTERESTS,
	ASSOCIATIONS,
}
